<template>
  <div class="col-xl-3 mb-3">
    <h5 class="title-section">Enrollment by Tier</h5>
    <div class="overallInfo-blockWrapper noHeight dashboard-card p-3 pb-2">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Tier</th>
              <th>Enrolled</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, tier) in memberDataByTier" :key="tier">
              <td>{{ formatTierName(tier) }}</td>
              <td>{{ data.active }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    memberDataByTier: Object
  },
  methods: {
    formatTierName(tier) {
      const tierMapping = {
        single: "Member",
        spouse: "Member + Spouse",
        family: "Family"
      };
      return tierMapping[tier] || tier;
    }
  }
};
</script>
